import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { ShipLink } from "utils/LinkUtils";
import { Fragment, ReactNode } from "react";
import type { AgreementDetailsByTypeProps } from "@schemas/agreements/schema";


type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const ShipAgreementDetails = ({ agreement, hiddenFields }: AgreementDetailsByTypeProps) => {

	const ShipAgreementDetailsFields: DetailsField[] = [
		{
			id: "agreement.ships",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "SHIPS" })} overflow="hidden">
						{agreement.ships?.map((a) => (
							<div style={{ margin: 0 }} key={a.id}>
								<ShipLink ship={a} />
							</div>
						))}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{ShipAgreementDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default ShipAgreementDetails;
